import { type PODisclaimerLabel } from '@webapp/modules/purchasing/entities/PODisclaimerLabel'
import { CreatePODisclaimerLabelForm } from '@webapp/modules/purchasing/features/create-po-disclaimer-label/views/CreatePODisclaimerLabelForm'
import { useCreatePODisclaimerLabelFormPresenter } from './useCreatePODisclaimerLabelFormPresenter'

export interface ICreatePODisclaimerLabelFormPresenterProps {
  existingLabels: PODisclaimerLabel[]
  onSuccess: () => void
  onCancel: () => void
}

export const CreatePODisclaimerLabelFormPresenter = ({
  existingLabels,
  onSuccess,
  onCancel,
}: ICreatePODisclaimerLabelFormPresenterProps) => {
  const {
    states: { isSaving },
    handlers: { handleSubmit },
  } = useCreatePODisclaimerLabelFormPresenter({
    existingLabels,
    onSuccess,
  })

  return (
    <CreatePODisclaimerLabelForm
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSaving={isSaving}
    />
  )
}

CreatePODisclaimerLabelFormPresenter.displayName =
  'CreatePODisclaimerLabelFormPresenter'
